import Store from '@/store'
import { postDataToCRM } from './logic/crm/index.js'

export default {
  emits: ['onClose', 'showModalAfterRequest'],
  data: function () {
    return {
      InnerIsShowModal: false,
    }
  },
  props: {
    isShowModal: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isShowModal: function() {
      this.InnerIsShowModal = this.isShowModal;
    }
  },
  methods: {
    modalOk () {
      Store.commit('setMXPreloader', true)
      this.modalClose()
      postDataToCRM()
        .then(_ => {
          let  crmResponse;
          eval('crmResponse = new Object(' + _.SaveWebFormObjectDataResult + ')'); // XSS security risk // convert to js object
          if (crmResponse.resultCode === 0) {
            window.location =  Store.state.logoutURL
          } else {
            console.log(_)
            this.$emit('showModalAfterRequest', {
              isModalShow: true
              // response: crmResponse 
            })
          }
        })
        .catch(console.error)
        .finally(() => {
          Store.commit('setMXPreloader', false)
        })
    },
    modalCrissCross () {
      this.modalClose()
    },
    modalClose () {
      this.InnerIsShowModal = false
      this.$emit('onClose')
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/profile-page/impl/delete-account/imlp/modal/script.js